import React from 'react';
import { languageSwitch } from '../../dictionary/translateFunctions';
import { useSelector } from 'react-redux';
import Fecha from '../fecha/Fecha'
import './pod.css';

const Pod = (props) => {
    const lang = useSelector((state) => state.lang.lang);
    return (
        <div className="aboutme_card">
            <div className="aboutme_card_arrow firstline">
            <div className="aboutme_card_left"></div>
            </div>

            <div className="aboutme_card_block">
                <div className={props.type === 'exp' ? 'aboutme_card_head' : 'aboutme_card_head_2'}>
                    {props.type === 'exp' ? 
                        (<p className="aboutme_card_fecha"> 
                                <Fecha date={props.objeto.fecha_inicio} /> - <Fecha date={props.objeto.fecha_hasta} />
                            </p>): 
                        (<p className="aboutme_card_fecha">
                                <Fecha date={props.objeto.fecha_desde} /> - <Fecha date={props.objeto.fecha_hasta} />
                            </p>)
                    }
                    <h5 className="aboutme_card_title">
                        {props.type === 'exp' ? languageSwitch(props.objeto.nombre_exp,lang) : languageSwitch(props.objeto.nombre_ed,lang)}
                    </h5>
                    <h6 className="aboutme_card_subtitle">
                        {props.type === 'exp' ? props.objeto.institucion_exp : props.objeto.institucion_ed}
                    </h6>
                    <span className="aboutme_card_p">
                        {
                            props.type === 'exp' ? 
                            (()=>
                                    {const m = new RegExp(/\. /g);
                                    const text = languageSwitch(props.objeto.descripcion_exp,lang)
        
                                    const elem = text.replace(m, ".<br /> ")
                                    const arr = elem.split('<br />');
                                    return arr.map((pr, index) => pr!==''?<p key={index}>{pr}</p>:'');}
                            )():<></>
                        }
                    </span>
                </div>
            </div>
            
        </div>
    )
}

export default Pod;